export const bindClickLogger = (element: HTMLElement, logClick: () => void) => {
  element.addEventListener('click', logClick, {capture: true, passive: true});
  return () => element.removeEventListener('click', logClick);
};
